import { render, staticRenderFns } from "./ReferralFollowupModal.vue?vue&type=template&id=16ae7837&"
import script from "./ReferralFollowupModal.vue?vue&type=script&lang=ts&"
export * from "./ReferralFollowupModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports